<template>
  <div :key="$store.getters['resource/currentResource'].key">
     <BillingInfoView/>
  </div>
</template>

<script>
import BillingInfoView from "@/views/billing/BillingInfoView";
export default {
  name: 'BillingInfo',
  middleware: 'auth',
  components: {BillingInfoView}
}
</script>
